/*
  Project: schrittweiter-chisel
  Author: schrittweiter GmbH
 */

import './modules/lazy'
import './modules/header'
import './modules/slider'
import './modules/accordion'
import './modules/scroll'
import './modules/process-chart'